import type { AiWalletTransaction } from "@/client/services/ai-credit/api";

export const TRANSACTION_LABELS: Record<AiWalletTransaction["type"], string> = {
  TOPUP: "Recharge de pack",
  GRANT: "Crédit offert",
  CONSUME: "Utilisation IA",
  REFUND: "Remboursement",
  ADJUST: "Ajustement",
  EXPIRE: "Crédits expirés",
};

export const POSITIVE_TRANSACTIONS = new Set<AiWalletTransaction["type"]>([
  "TOPUP",
  "GRANT",
  "REFUND",
  "ADJUST",
]);

export const formatTransactionDate = (iso: string) =>
  new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(iso));

export const formatExpiryDate = (iso?: string | null) =>
  iso
    ? new Intl.DateTimeFormat("fr-FR", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }).format(new Date(iso))
    : null;
